(function ($) {

    var siteHeader = document.getElementById('siteHeader');

    if (!siteHeader) return;

    var siteMain = document.getElementById('siteMain');
    var siteHeaderHeight = $(siteHeader).outerHeight();
    var fixed = siteHeader.offsetTop;
    var fixedOffset = siteHeader.offsetTop;

    function stickyHeader() {


        // Toggle scrolled class
        if (window.pageYOffset > fixedOffset) {
            $(siteHeader).addClass('is-fixed');
            $(siteMain).css('padding-top', siteHeaderHeight + 'px');

        } else {
            $(siteHeader).removeClass('is-fixed');
            $(siteMain).css('padding-top', '0');
        }

    }

    window.onscroll = function () {
        stickyHeader();
    };

}(jQuery));
